import moment from 'moment'
import axios from "@/settings/axios";
import { apiSettings } from '@/settings/api'


// let tp = new Typograf({ locale: ["ru", "en-US"] });
moment.locale('ru');

export function declOfNum(number, titles) {
    let cases = [2, 0, 1, 1, 1, 2];
    return titles[(number % 100 > 4 && number % 100 < 20) ? 2 : cases[(number % 10 < 5) ? number % 10 : 5]];
}

export const tokenMethods = (function () {
    function setToken(token = '', cb = () => { }) {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
        localStorage.setItem('fotty_token', token)
        cb();
    }

    function removeToken(cb = () => { }) {
        axios.defaults.headers.common['Authorization'] = '';
        localStorage.removeItem('fotty_token');
        cb();
    }
    return {
        setToken, removeToken
    }
})()




export function DropZoneBaseOptions() {
    let token = localStorage.getItem('fotty_token') || '';
    return {
        url: axios.defaults.baseURL +
            "/files/" +
            apiSettings.files_ver +
            "/upload",
        headers: {
            Authorization: "Bearer " + token
        },
        createImageThumbnails: false
    }
}

export function Default_style() {
    return {
        "bg": "#F8F8F8",
        "bgDark": "#000000",
        "boardingDark": "#1C1C1C",
        "borderRadius": 8.0,
        "card": "#FFFFFF",
        "cardDark": "#333333",
        "color": "#FFFFFF",
        "colorDark": "#000000",
        "font": "System",
        "fontSize15": 15,
        "fontSize17": 17,
        "fontSize22": 22,
        "line": "#E0E0E0",
        "lineDark": "#333333",
        "marginContentX": 24,
        "marginContentY": 16,
        "marginX": 16,
        "marginY": 16,
        "primary": "#301C99",
        "shadow": "#8E8E8E",
        "shadowOffsetX": 0,
        "shadowOffsetY": 0,
        "shadowOpacity": 0.35,
        "shadowRadius": 8,
        "textGray": "#8E8E8E",
        "textGrayDark": "#B8B8B8"
    }
}

export function Default_event() {
    return {
        title: '',
        place: '',
        cover_id: '',
        date_at: new Date,
        style_id: '',
        tariff_id:'',
    }
}

export function Default_post() {
    return {
        title: '',
        text: '',
        button: '',
        promocode: '',
        link: '',
        files: [], //{link:'',id:''}
    }
}
export function User_info() {
    return {
        name: {
            value: "",
            default: "Имя Фамилия"
        },
        layout: '',
        layout_id: '',
        avatar: '',
        avatar_id: '',
        regdate: moment().format(),
        phone: "",
        email: "",
        socials: {
            site: {
                icon: "web",
                title: "Сайт",
                size: [20, 20],
                link: "",
                placeholder: "Сайт",
                subholder: "Сайт",
                name: "site",
                base_url: '',
                view: ''
            },
            insta: {
                icon: "inst",
                title: "Instagram",
                size: [20, 20],
                link: "",
                placeholder: "Инстаграм",
                subholder: "Инстаграм",
                name: "insta",
                base_url: 'https://instagram.com/',
                view: ''
            },
            // mywed: {
            //     icon: "wed",
            //     title: "MyWed",
            //     size: [20, 20],
            //     link: "",
            //     name:"mywed",
            //     placeholder:"MyWed",
            //     subholder:"MyWed",
            //     base_url:'https://mywed.com/'
            // },
            fb: {
                icon: "fb",
                title: "Facebook",
                size: [20, 20],
                link: "",
                name: "fb",
                placeholder: "Facebook",
                subholder: "Facebook",
                base_url: 'https://facebook.com/',
                view: ''
            },
            vk: {
                icon: "vk",
                title: "Вконтакте",
                size: [20, 20],
                link: "",
                name: "vk",
                placeholder: "Вконтакте",
                subholder: "Вконтакте",
                base_url: 'https://vk.com/',
                view: ''
            }
        }
    }
}

const hexToRgb = (hex) => {
    let shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    hex = hex.replace(shorthandRegex, function (m, r, g, b) {
        return r + r + g + g + b + b;
    });

    let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
    } : null;
};

export const rgba = (hex, alpha) => {
    const color = hexToRgb(hex);
    return `rgba(${color.r}, ${color.g}, ${color.b}, ${alpha})`;
};
